(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.querySelectorAll('[data-abar-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.abar').remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cartpg]').forEach(function (form) {
    var updateBtn = form.querySelector('[data-cartpg-update]');
    if (updateBtn) updateBtn.style.display = 'none';
    form.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        form.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Sortierung wechselt sofort (ohne JS funktioniert der «Anwenden»-Button genauso)
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-popup]').forEach(function (root) {
    var id = 'mediair-popup-' + root.dataset.popupId;
    var frequency = root.dataset.popupFrequency;
    var delay = parseInt(root.dataset.popupDelay, 10) * 1000 || 0;

    var isEditor = window.Shopify && window.Shopify.designMode;
    if (!isEditor && frequency === 'session' && sessionStorage.getItem(id)) return;
    if (!isEditor && frequency === 'month') {
      var seen = localStorage.getItem(id);
      if (seen && Date.now() - parseInt(seen, 10) < 30 * 24 * 3600 * 1000) return;
    }

    function close() {
      root.hidden = true;
      if (frequency === 'session') sessionStorage.setItem(id, '1');
      if (frequency === 'month') localStorage.setItem(id, String(Date.now()));
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    root.querySelectorAll('[data-popup-close], [data-popup-close-veil]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    var cd = root.querySelector('[data-countdown]');
    function tickCountdown() {
      if (!cd) return;
      var target = new Date(cd.dataset.countdown).getTime();
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      cd.querySelector('[data-cd-days]').textContent = d;
      cd.querySelector('[data-cd-hours]').textContent = h;
      cd.querySelector('[data-cd-mins]').textContent = m;
      if (diff > 0) setTimeout(tickCountdown, 30000);
    }

    var hasNewsletterSuccess = root.querySelector('.popup__success');
    setTimeout(function () {
      root.hidden = false;
      tickCountdown();
      document.addEventListener('keydown', onKey);
      var closeBtn = root.querySelector('[data-popup-close]');
      if (closeBtn) closeBtn.focus();
    }, hasNewsletterSuccess ? 0 : delay);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recommendations]').forEach(function (container) {
    fetch(container.dataset.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var fresh = html.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          container.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {
        /* Empfehlungen sind optional — Fehler still schlucken */
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Galerie: Thumbnail-Klick tauscht das Hauptbild
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.pdp__main-img');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.galleryThumb;
        main.removeAttribute('srcset');
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // Variantenwahl: Preis-Anzeige aktualisieren
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var priceEl = select.closest('.pdp__info');
    priceEl = priceEl && priceEl.querySelector('[data-price]');
    if (!priceEl) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-finder]').forEach(function (finder) {
    var steps = Array.prototype.slice.call(finder.querySelectorAll('[data-finder-step]'));
    var results = Array.prototype.slice.call(finder.querySelectorAll('[data-finder-result]'));
    var bar = finder.querySelector('[data-finder-bar]');
    if (!steps.length) return;

    var votes = [];

    function show(index) {
      steps.forEach(function (s, i) {
        s.hidden = i !== index;
      });
      results.forEach(function (r) {
        r.hidden = true;
      });
      if (bar) bar.style.width = (index / steps.length) * 100 + '%';
    }

    function finish() {
      steps.forEach(function (s) {
        s.hidden = true;
      });
      if (bar) bar.style.width = '100%';
      var tally = {};
      votes.forEach(function (v) {
        if (v) tally[v] = (tally[v] || 0) + 1;
      });
      var winner = null;
      var max = -1;
      Object.keys(tally).forEach(function (key) {
        if (tally[key] > max) {
          max = tally[key];
          winner = key;
        }
      });
      var el = null;
      results.forEach(function (r) {
        if (r.dataset.finderResult === winner) el = r;
      });
      if (!el) el = results[0];
      if (el) el.hidden = false;
    }

    steps.forEach(function (step, index) {
      step.querySelectorAll('[data-finder-vote]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          votes[index] = btn.dataset.finderVote;
          if (index + 1 < steps.length) {
            show(index + 1);
          } else {
            finish();
          }
        });
      });
      var back = step.querySelector('[data-finder-back]');
      if (back) {
        back.addEventListener('click', function () {
          show(Math.max(0, index - 1));
        });
      }
    });

    finder.querySelectorAll('[data-finder-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        votes = [];
        show(0);
      });
    });

    show(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-slider-dot]'));
    var count = track.children.length;

    function index() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function go(i) {
      var target = Math.max(0, Math.min(count - 1, i));
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    track.addEventListener('scroll', function () {
      var i = index();
      dots.forEach(function (d, j) {
        d.classList.toggle('on', j === i);
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
